import { Type } from 'class-transformer'
import { User } from '@/dtos/commons'

export class SimpleRepairPlanUpdatesLatestCommentResponse {
  commentId?: string
  comment?:string
  postedAt?: string
  @Type(() => User) user = new User()
}
